import { Plane } from 'lucide-react';

const EditFlight = ({ voucherData, t, formatDateTime, styles }) => {
  return (
    <div className="pdf-section">
      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          <Plane size={20} />
          {t('flightInformation')}
        </div>
        <div style={{ marginBottom: '16px' }}>
          <div style={styles.infoGrid}>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('airline')}</div>
              <div style={styles.infoValue}>
                {voucherData.booking_flight?.airline?.code} {voucherData.booking_flight?.airline?.name}
              </div>
            </div>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('tripType')}</div>
              <div style={styles.infoValue}>
                {voucherData.booking_flight?.trip === 'roundtrip' ? t('roundTrip') : 
                 voucherData.booking_flight?.trip === 'oneway' ? t('oneWay') : 
                 voucherData.booking_flight?.trip}
              </div>
            </div>
          </div>
          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('passengers')}</div>
            <div style={styles.infoValue}>
              <span>{t('adults')}: {voucherData.booking_flight?.adult || 0}</span>
              <span style={{ margin: '0 12px' }}>•</span>
              <span>{t('children')}: {voucherData.booking_flight?.child || 0}</span>
              <span style={{ margin: '0 12px' }}>•</span>
              <span>{t('infants')}: {voucherData.booking_flight?.infant || 0}</span>
            </div>
          </div>
        </div>

        {voucherData.booking_flight?.itineraries && voucherData.booking_flight.itineraries.length > 0 && (
          <div>
            {voucherData.booking_flight.itineraries.map((itinerary, index) => (
              <div key={index} style={{ 
                marginBottom: '24px', 
                padding: '16px', 
                background: index % 2 === 0 ? '#f8fafc' : 'white',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                {/* Header du segment */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: '16px',
                  paddingBottom: '8px',
                  borderBottom: '1px solid #d1d5db'
                }}>
                  <div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                      {t('flight')} {index + 1}: {itinerary.departure?.code} → {itinerary.arrival?.code}
                    </div>
                    <div style={{ fontSize: '14px', color: '#6b7280' }}>
                      {itinerary.departure?.name} → {itinerary.arrival?.name}
                    </div>
                  </div>
                </div>

                {/* Détails des segments */}
                {itinerary.segments && itinerary.segments.map((segment, segIndex) => (
                  <div key={segIndex} style={{ marginBottom: segIndex < itinerary.segments.length - 1 ? '20px' : '0' }}>
                    {/* Header du vol */}
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '12px',
                      background: '#f1f5f9',
                      padding: '12px',
                      borderRadius: '6px'
                    }}>
                      <div>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#7c3aed' }}>
                          {segment.airline?.code} {segment.flightNumber}
                        </div>
                        <div style={{ fontSize: '14px', color: '#6b7280' }}>
                          {segment.airline?.name}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
                          {t('duration')}: {segment.duration}
                        </div>
                      </div>
                    </div>

                    {/* Détails départ/arrivée */}
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: '1fr auto 1fr',
                      gap: '16px',
                      alignItems: 'center'
                    }}>
                      {/* Départ */}
                      <div>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                          {segment.departure?.code}
                        </div>
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                          {segment.departure?.name}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                          {formatDateTime(segment.departure?.date)}
                        </div>
                        {segment.departure?.terminal && (
                          <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>
                            {t('terminal')}: {segment.departure.terminal}
                          </div>
                        )}
                      </div>

                      {/* Flèche */}
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ 
                          width: '40px', 
                          height: '40px',
                          background: '#7c3aed',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto'
                        }}>
                          <Plane size={20} color="white" />
                        </div>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                          {segment.duration}
                        </div>
                      </div>

                      {/* Arrivée */}
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                          {segment.arrival?.code}
                        </div>
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                          {segment.arrival?.name}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                          {formatDateTime(segment.arrival?.date)}
                        </div>
                        {segment.arrival?.terminal && (
                          <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>
                            {t('terminal')}: {segment.arrival.terminal}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};


export default EditFlight;